import { DomainBase } from "./DomainBase";

export class UserSpecialPermission extends DomainBase{
    constructor() {
        super();
        this.UserRole = null; //UserRole Class
        this.userSpecialPermissionList = null; //SpecialPermission
    }
}